import { render, staticRenderFns } from "./DesktopAddressbookItem.vue?vue&type=template&id=34beb5e9"
import script from "./DesktopAddressbookItem.vue?vue&type=script&lang=js"
export * from "./DesktopAddressbookItem.vue?vue&type=script&lang=js"
import style0 from "./DesktopAddressbookItem.vue?vue&type=style&index=0&id=34beb5e9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports